module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/kaede-funakoshi-cc069492ead6b8c9c93f62e27bf2181b.webp";